import { Button } from "../Button";
import { ActionProps } from "./Action.props";

export const Action = ({ className, variant, action }: ActionProps) => {
  if (!action) return null;

  const { ariaLabel, text } = action;
  const href = "href" in action ? action.href : undefined;
  const onClick = "onClick" in action ? action.onClick : undefined;
  const isHttpLink = !!href?.startsWith("http");

  return (
    <Button
      ariaLabel={ariaLabel}
      className={className}
      variant={variant}
      onClick={onClick}
      href={href}
      newTab={isHttpLink ? true : undefined}
    >
      {text}
    </Button>
  );
};
